import { render } from "./chart-ca-users.vue?vue&type=template&id=587dc3a0"
import script from "./chart-ca-users.vue?vue&type=script&lang=js"
export * from "./chart-ca-users.vue?vue&type=script&lang=js"

import "./chart-ca-users.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script